import store from '../store'
class Cache {
  put(key: string, value: any) {
    store.commit('setOther', { [key]: value })
  }
  get(key: string) {
    var value = store.getters.other[key]
    if (!value) {
      return ''
    }
    return JSON.parse(JSON.stringify(store.getters.other[key]))
  }
  clear() {
    store.commit('clearOther', {})
  }
}
const cache: Cache = new Cache()

export default cache
